<template>
  <div  class="wet-section">
    <!-- LOGOUT -->
  </div>
</template>
<script>
import partnerCodeMixin from '@/mixins/partner-code';
import configEnv from "@/enums/configEnv";
import LogService from "@/services/LogService";

export default {
  name: 'LogoutView',
  mixins: [partnerCodeMixin],
  mounted() {
    // logout user
    this.$logout()
      .finally(() => {
        // redirect
        if (this.$route.query.redirect) {
          LogService.log('redirect', configEnv.logout_redirect, this.$route.query.redirect);
          this.$router.push({
            name: this.$route.query.redirect,
            params: { ...this.$route.params },
          });
        } else {
          LogService.log('redirect', configEnv.logout_redirect);
          this.$router.push({ name: configEnv.logout_redirect }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      });
  },
};
</script>
